import React from "react";
import {
  Badge,
  Caption1,
  Table,
  TableBody,
  TableCell,
  TableCellLayout,
  TableHeader,
  TableHeaderCell,
  TableRow
} from "@fluentui/react-components";
import { User } from "../../model/model";
import { EmptyState } from "../common/EmptyState";
import { DeleteUserDialog } from "./DeleteUserDialog";

interface UsersTableProps {
  users: User[];
  deletingUserId?: string;
  onDelete: (userId: string, tenantId: string) => Promise<void>;
}

export const UsersTable: React.FC<UsersTableProps> = ({ users, deletingUserId, onDelete }) => {
  if (!users.length) {
    return (
      <EmptyState
        title="No registered users"
        description="No seats are currently assigned in this tenant."
      />
    );
  }

  return (
    <Table aria-label="Tenant users">
      <TableHeader>
        <TableRow>
          <TableHeaderCell>User ID</TableHeaderCell>
          <TableHeaderCell>Email</TableHeaderCell>
          <TableHeaderCell>Activity</TableHeaderCell>
          <TableHeaderCell>Action</TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {users.map((user) => (
          <TableRow key={`${user.tenantId}-${user.userId}`}>
            <TableCell>
              <TableCellLayout truncate>{user.userId}</TableCellLayout>
            </TableCell>
            <TableCell>
              <TableCellLayout truncate>{user.email}</TableCellLayout>
            </TableCell>
            <TableCell>
              {user.lastActivity ? (
                <Caption1>{new Date(user.lastActivity).toLocaleString()}</Caption1>
              ) : (
                <Badge appearance="outline">No activity</Badge>
              )}
            </TableCell>
            <TableCell>
              <DeleteUserDialog
                disabled={deletingUserId === user.userId}
                email={user.email}
                onConfirm={() => onDelete(user.userId, user.tenantId)}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
